import { styled } from '@material-ui/core/styles';

export const ModalWrapper = styled('div')({
  display: 'grid',
  gap: '1rem',
  width: '30rem',
  textAlign: 'center',
  padding: '0rem 2rem',
  justifyContent: 'center',
  '& video': {
    width: '10rem',
    height: '10rem',
    margin: '0 auto',
  },
  '& button': {
    width: '12rem',
    margin: '0 auto',
  },
});

export const TitleModal = styled('h1')(({ theme }) => ({
  fontSize: theme.font.sizes.small,
  color: theme.colors.gray,
}));
